import React, { useState, useEffect } from "react";
import styled from "styled-components";
import { setDoc, collection, addDoc } from "firebase/firestore";
import { db } from "./Firebase";
import { FormGroup } from "./CostCalculadora";
import { EstiloButton } from "./App";
import { Alert, CloseButton } from "./App";
import { userName, userEmail } from "./UserData";

const ContenedorFormBase = styled.div`
  margin: auto;
  margin-top: 1.5rem;
  text-align: center;
  width: 380px;
  @media only screen and (min-width: 320px) and (max-width: 768px) {
    width: 330px;
  }
`;
const FormDiv = styled.div`
  margin-bottom: 3rem;
  p {
    margin: 0px;
  }
`;

const PresupuestoForm = ({ generarPresupuesto }) => {
  const [fecha, setFecha] = useState("");
  const [nombre, setNombre] = useState("");
  const [empresa, setEmpresa] = useState("");
  const [telefonoCliente, setTelefonoCliente] = useState("");
  const [emailCliente, setEmailCliente] = useState("");
  const [fechaSalida, setFechaSalida] = useState("");
  const [horaSalida, setHoraSalida] = useState("");
  const [lugarSalida, setLugarSalida] = useState("");
  const [cantidadPasajeros, setCantidadPasajeros] = useState("");
  const [unidadesSolicitadas, setUnidadesSolicitadas] = useState("");
  const [tipoServicio, setTipoServicio] = useState("");
  const [lugarDestino, setLugarDestino] = useState("");
  const [kilometrosAdicionales, setKilometrosAdicionales] = useState("");
  const [fechaRegreso, setFechaRegreso] = useState("solo ida");
  const [horaRegreso, setHoraRegreso] = useState("");
  const [tarifaPorPasajero, setTarifaPorPasajero] = useState("$");
  const [totalServicio, setTotalServicio] = useState("$  (  pesos arg.)");
  const [observaciones, setObservaciones] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  // Datos para el ejecutivo comercial
  const [nombreEjecutivo, setNombreEjecutivo] = useState("");
  const [correoEjecutivo, setCorreoEjecutivo] = useState("");
  const [telefonoEjecutivo, setTelefonoEjecutivo] = useState("");
  const [missingFields, setMissingFields] = useState([]);

  useEffect(() => {
    setNombreEjecutivo(userName); // Actualiza firmaCorreo con userName
    setCorreoEjecutivo(userEmail);
  }, []);

  const [showAlert, setShowAlert] = useState(false);
  const closeAlert = () => {
    setShowAlert(false);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (isSubmitting) return; // evita doble click rápido

    setIsSubmitting(true); // bloquear

    // Validar que los campos obligatorios no estén vacíos
    const camposFaltantes = [];

    if (!fecha.trim()) camposFaltantes.push("fecha");
    if (!nombre.trim()) camposFaltantes.push("nombre");
    if (!empresa.trim()) camposFaltantes.push("empresa");
    if (!telefonoCliente.trim()) camposFaltantes.push("telefono cliente");
    if (!emailCliente.trim()) camposFaltantes.push("correo cliente");
    if (!fechaSalida.trim()) camposFaltantes.push("fecha de salida");
    if (!lugarSalida.trim()) camposFaltantes.push("lugar de salida");
    if (!cantidadPasajeros.trim())
      camposFaltantes.push("cantidad de pasajeros");
    if (!unidadesSolicitadas.trim())
      camposFaltantes.push("unidades solicitadas");
    if (!tipoServicio.trim()) camposFaltantes.push("tipo de servicio");
    if (!lugarDestino.trim()) camposFaltantes.push("lugar de destino");
    if (!totalServicio.trim()) camposFaltantes.push("total del servicio");

    if (camposFaltantes.length > 0) {
      setMissingFields(camposFaltantes);
      // Mostrar mensaje de error o realizar alguna acción
      setShowAlert(true);
      setIsSubmitting(false);
      return;
    }

    // Validar que los campos numéricos contengan valores válidos
    if (
      isNaN(cantidadPasajeros) ||
      isNaN(unidadesSolicitadas) ||
      isNaN(kilometrosAdicionales)
    ) {
      // Mostrar mensaje de error o realizar alguna acción
      setShowAlert(true);
      setIsSubmitting(false);
      return;
    }

    // Guardar los datos en Firestore y luego pasar los datos con el docId a generarPresupuesto
    await guardarEnFirestore(generarPresupuesto);
  };

  const guardarEnFirestore = async (generarPresupuesto) => {
    try {
      const presupuestosRef = collection(db, "presupuestos");
      const docRef = await addDoc(presupuestosRef, {
        fecha,
        nombre,
        empresa,
        telefonoCliente,
        emailCliente,
        fechaSalida,
        horaSalida,
        lugarSalida,
        cantidadPasajeros,
        unidadesSolicitadas,
        tipoServicio,
        lugarDestino,
        kilometrosAdicionales,
        fechaRegreso,
        horaRegreso,
        tarifaPorPasajero,
        totalServicio,
        observaciones,
        nombreEjecutivo,
        correoEjecutivo,
        telefonoEjecutivo,
      });

      // Obtiene el ID del documento
      const docId = docRef.id;

      // Actualiza el documento para añadir el campo con el ID
      await setDoc(docRef, {
        docId: docId, // Añade el campo 'docId' con el ID del documento
        fecha,
        nombre,
        empresa,
        telefonoCliente,
        emailCliente,
        fechaSalida,
        horaSalida,
        lugarSalida,
        cantidadPasajeros,
        unidadesSolicitadas,
        tipoServicio,
        lugarDestino,
        kilometrosAdicionales,
        fechaRegreso,
        horaRegreso,
        tarifaPorPasajero,
        totalServicio,
        observaciones,
        nombreEjecutivo,
        correoEjecutivo,
        telefonoEjecutivo,
      });

      // Aquí pasamos los datos a generarPresupuesto con el docId incluido
      generarPresupuesto({
        docId, // Incluimos el docId
        fecha,
        nombre,
        empresa,
        telefonoCliente,
        emailCliente,
        fechaSalida,
        horaSalida,
        lugarSalida,
        cantidadPasajeros,
        unidadesSolicitadas,
        tipoServicio,
        lugarDestino,
        kilometrosAdicionales,
        fechaRegreso,
        horaRegreso,
        tarifaPorPasajero,
        totalServicio,
        observaciones,
        nombreEjecutivo,
        correoEjecutivo,
        telefonoEjecutivo,
      });

      console.log("Datos guardados en Firestore");
    } catch (error) {
      console.error("Error al guardar en Firestore:", error);
    }
  };

  return (
    <ContenedorFormBase>
      {showAlert && (
        <Alert>
          <CloseButton onClick={closeAlert}>&times;</CloseButton>
          <h6>Faltan los siguientes campos por completar:</h6>
          <ul>
            {missingFields.map((field, index) => (
              <li key={index}>{field}</li>
            ))}
          </ul>
        </Alert>
      )}
      <h4>Generar Presupuesto</h4>
      <FormDiv>
        <form onSubmit={handleSubmit}>
          <FormGroup>
            <label>Fecha:</label>
            <input
              type="date"
              value={fecha}
              onChange={(e) => setFecha(e.target.value)}
            />
          </FormGroup>
          <FormGroup>
            <label>Nombre del responsable:</label>
            <input
              placeholder="nombre completo"
              type="text"
              value={nombre}
              onChange={(e) => setNombre(e.target.value)}
            />
          </FormGroup>
          <FormGroup>
            <label>Empresa o Institución:</label>
            <input
              type="text"
              value={empresa}
              onChange={(e) => setEmpresa(e.target.value)}
            />
          </FormGroup>
          <FormGroup>
            <label>Telefono/WhatsApp:</label>
            <input
              type="tel"
              value={telefonoCliente}
              onChange={(e) => setTelefonoCliente(e.target.value)}
            />
          </FormGroup>
          <FormGroup>
            <label>Email:</label>
            <input
              type="email"
              value={emailCliente}
              onChange={(e) => setEmailCliente(e.target.value)}
            />
          </FormGroup>
          <FormGroup>
            <label>Fecha de Salida:</label>
            <input
              type="date"
              value={fechaSalida}
              onChange={(e) => setFechaSalida(e.target.value)}
            />
          </FormGroup>
          <FormGroup>
            <label>Hora de Salida:</label>
            <input
              type="time"
              value={horaSalida}
              onChange={(e) => setHoraSalida(e.target.value)}
            />
          </FormGroup>
          <FormGroup>
            <label>Lugar de Salida:</label>
            <input
              type="text"
              value={lugarSalida}
              onChange={(e) => setLugarSalida(e.target.value)}
            />
          </FormGroup>
          <FormGroup>
            <label>Cantidad de Pasajeros:</label>
            <input
              type="number"
              value={cantidadPasajeros}
              onChange={(e) => setCantidadPasajeros(e.target.value)}
            />
          </FormGroup>
          <FormGroup>
            <label>Unidades Solicitadas:</label>
            <input
              type="number"
              value={unidadesSolicitadas}
              onChange={(e) => setUnidadesSolicitadas(e.target.value)}
            />
          </FormGroup>
          <FormGroup>
            <label>Catering u otro Servicio:</label>
            <input
              type="text"
              value={tipoServicio}
              onChange={(e) => setTipoServicio(e.target.value)}
            />
          </FormGroup>
          <FormGroup>
            <label>Lugar de Destino:</label>
            <input
              type="text"
              value={lugarDestino}
              onChange={(e) => setLugarDestino(e.target.value)}
            />
          </FormGroup>
          <FormGroup>
            <label>Km. en Destino:</label>
            <input
              type="number"
              value={kilometrosAdicionales}
              onChange={(e) => setKilometrosAdicionales(e.target.value)}
            />
          </FormGroup>
          <FormGroup>
            <label>Fecha de Regreso:</label>
            <input
              type="date"
              value={fechaRegreso}
              onChange={(e) => setFechaRegreso(e.target.value)}
            />
          </FormGroup>
          <FormGroup>
            <label>Hora de Regreso:</label>
            <input
              type="time"
              value={horaRegreso}
              onChange={(e) => setHoraRegreso(e.target.value)}
            />
          </FormGroup>
          <FormGroup>
            <label>Total del Servicio:</label>
            <input
              type="text"
              value={totalServicio}
              onChange={(e) => setTotalServicio(e.target.value)}
            />
          </FormGroup>
          <FormGroup>
            <label>Tarifa por Pasajero:</label>
            <input
              type="text"
              value={tarifaPorPasajero}
              onChange={(e) => setTarifaPorPasajero(e.target.value)}
            />
          </FormGroup>
          <FormGroup>
            <label>Observaciones:</label>
            <textarea
              value={observaciones}
              onChange={(e) => setObservaciones(e.target.value)}
              rows="2"
              cols="50"
            />
          </FormGroup>
          <FormGroup>
            <label>Ejecutivo Comercial:</label>
            <input
              type="text"
              value={nombreEjecutivo}
              onChange={(e) => setNombreEjecutivo(e.target.value)}
            />
          </FormGroup>
          <FormGroup>
            <label>Correo Ejecutivo:</label>
            <input
              type="email"
              value={correoEjecutivo}
              onChange={(e) => setCorreoEjecutivo(e.target.value)}
            />
          </FormGroup>
          <FormGroup>
            <label>Teléfono Ejecutivo:</label>
            <input
              type="tel"
              value={telefonoEjecutivo}
              onChange={(e) => setTelefonoEjecutivo(e.target.value)}
            />
          </FormGroup>
          <EstiloButton type="submit" disabled={isSubmitting}>
            {isSubmitting ? "Generando..." : "Generar Presupuesto"}
          </EstiloButton>
        </form>
      </FormDiv>
    </ContenedorFormBase>
  );
};

export default PresupuestoForm;
